<template>
<div class="upgrade-link">
	&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
    <form method="POST" style="display:inline;">
        <input type="hidden" name="ACTION" value="USERUPGRADE" v-model="ACTION" />
        <button class="link-E font-E2 shadowed-text link-button" >upgrade</button>
    </form>
    <p class="link-E shadowed-text" style="margin-bottom: 20px; display:inline-block;">to enhanced high speed for a nominal fee</p>
</div>
</div>
</template>

<script>

export default {
  name: "UpgradeLink",
  data() {
  	ACTION: null
  }
}

</script>

<style scoped>

</style>